module.exports = __webpack_public_path__ + "static/media/Bhaksar Kogga Kamath.bfd7caab.jpg";